var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeakerOn2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 34,
    viewBox: "0 0 40 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1646_3370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.55568 10.748H1.17969V23.2535H8.55568L17.9011 32.8238V1.17773L8.55568 10.748Z",
    stroke: "#FAC300",
    strokeWidth: 2.21739,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4297 30.9398C35.4422 27.5927 38.0017 22.5685 38.0017 16.9411C38.0017 11.3137 35.4422 6.28942 31.4297 2.94238",
    stroke: "#FAC300",
    strokeWidth: 2.21739,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2109 26.7471C30.1687 24.4888 32.0938 20.9431 32.0938 16.9487C32.0938 12.9544 30.1761 9.40136 27.2109 7.15039",
    stroke: "#FAC300",
    strokeWidth: 2.21739,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9844 22.5249C24.9095 21.3994 26.2077 19.325 26.2077 16.949C26.2077 14.573 24.9095 12.4912 22.9844 11.373",
    stroke: "#FAC300",
    strokeWidth: 2.21739,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1646_3370"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.1739,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerOn2);
export default __webpack_public_path__ + "static/media/speaker-on-2.55ebb3f49a8e24793f2354fb2a3b903d.svg";
export { ForwardRef as ReactComponent };